export const LANGUAGE_IDS = {
    'en': 1,
    'es': 2
}
